const {v4: uuidv4} = require('uuid');

export const getUiIdForPart = ()=>{
    return {
        uuid: uuidv4()
    }
}